const MAX_BROWSER_FRACTION_SUPPORT = 20;

const formatNumber = (
	value: number,
	currency = 'USD',
	isCompact = false,
	style: 'decimal' | 'currency' = 'currency',
): string => {
	if (value === null) return null;

	const isNegative = value < 0;
	let max: number;
	let extra = 0;
	const isInteger = value > 999999 ? Number.isInteger(Math.round(value)) : Number.isInteger(value);

	if (Math.round(value) >= 1 || Math.round(value) <= -1 || value === 0) {
		max = 2;
	} else if (value !== 0) {
		max = Math.abs(Math.floor(Math.log10(isNegative ? value * -1 : value) + 1));
		extra = 3;
	}

	let fractionDigits = extra + (isInteger && !isCompact ? 0 : max);
	fractionDigits =
		fractionDigits > MAX_BROWSER_FRACTION_SUPPORT ? MAX_BROWSER_FRACTION_SUPPORT : fractionDigits;

	return value.toLocaleString('en-EN', {
		style,
		...(currency ? { currency: currency.toUpperCase() } : {}),
		notation: isCompact ? 'compact' : 'standard',
		maximumFractionDigits: fractionDigits,
		minimumFractionDigits: fractionDigits,
	});
};
export default formatNumber;
